// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");

function createError(prim, prim$1) {
  return $dot$dot.createError(prim, prim$1);
}

exports.createError = createError;
/* .. Not a pure module */
